
export const rounds = {
  title: "Támogatott valuták és kerekítési szabályok",
  columns: {
    currency: "Támogatott valuták",
    iso: "ISO kód",
    location: "Hely, ahol használatos",
    minPrice: "Minimális nettó ár",
    roundTo: "Bruttó ár felkerekítve a következő lehetséges számjegyekre"
  }
};
